<template>
  <div class="module1">
    <div class="module">
      <div class="num">{{data.num}}</div>
      <div class="name">{{data.name}}</div>
      <div class="p">{{data.p}}</div>
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "module1",
  props: ["data"],
  data() {
    return {};
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.module1 {
  margin-top: 60px;
  .num {
    font-size: 80px;
    color: rgba(238, 238, 238, 1);
    text-align: center;
  }
  .name {
    font-size: 38px;
    color: rgba(58, 58, 58, 1);
    text-align: center;
    margin-top: -43px;
  }
  .p {
    font-size: 16px;
    color: rgba(124, 124, 124, 1);
    line-height: 32px;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/templates/module1.vue